import "../../helpers/handlebars-helpers.js";
import * as RX from "rxjs";
import { Failure } from "src/js/helpers/failure.js";
import _ from "lodash";
import { option } from "fp-ts";
import { Option } from "fp-ts/Option";
import { pipe } from "fp-ts/lib/function.js";

export class Button {
  static onClick$(button: HTMLElement): RX.Observable<HTMLElement> {
    return RX.fromEvent(button, "click").pipe(RX.map(GetEventTarget));
  }
}

export class ToggleableButton {
  static getState$(
    button: HTMLElement,
    initialState: Option<Boolean> = option.none
  ): RX.Observable<Boolean> {
    const initialValue = pipe(
      initialState,
      option.getOrElse(() => hasClass(button, "active"))
    );
    const isActive$ = Button.onClick$(button).pipe(
      RX.map((element) => !hasClass(element, "active")),
      RX.startWith(initialValue),
      RX.tap((isActive) =>
        isActive
          ? button.classList.add("active")
          : button.classList.remove("active")
      ),
      RX.shareReplay(1)
    );

    return isActive$;
  }
}

function hasClass(element: HTMLElement, className: string): Boolean {
  return element.classList.contains(className);
}

function GetEventTarget(clickEvent: Event): HTMLElement {
  if (
    clickEvent.currentTarget == null ||
    clickEvent.currentTarget instanceof HTMLElement == false
  ) {
    Failure("Event contains no target element");
  }
  return clickEvent.currentTarget;
}
